const getSuffix = (filename: string) => {
  const dotIndex = filename.lastIndexOf('.');
  return dotIndex !== -1 ? filename.slice(dotIndex + 1) : 'N/A';
};

export default getSuffix;
